/**
 * Repositorio de ajustes — singleton.
 *
 * La clave `id: 'singleton'` existe SOLO en el almacenamiento. El repositorio
 * la oculta al devolver el objeto de dominio: el tipo `Ajustes` no la conoce.
 *
 * Los ajustes NO se sincronizan: el tema es una preferencia del dispositivo
 * (oscuro en el teléfono, claro en la PC es un caso legítimo). Por eso no
 * llevan metadatos de sincronización.
 */

import { liveQuery, type Observable } from 'dexie';

import {
  AJUSTES_POR_DEFECTO,
  CLAVE_AJUSTES,
  type Ajustes,
} from '../domain/modelo/ajustes.js';
import { db, escribir } from './db.js';

export const ajustesRepo = {
  async obtener(): Promise<Ajustes> {
    const almacenados = await db.ajustes.get(CLAVE_AJUSTES);
    if (!almacenados) return { ...AJUSTES_POR_DEFECTO };
    const { id: _id, ...ajustes } = almacenados;
    return ajustes;
  },

  observar(): Observable<Ajustes> {
    return liveQuery(async () => ajustesRepo.obtener());
  },

  async guardar(cambios: Partial<Ajustes>): Promise<Ajustes> {
    const actuales = await ajustesRepo.obtener();
    const nuevos = { ...actuales, ...cambios };
    await escribir('guardar los ajustes', () =>
      db.ajustes.put({ id: CLAVE_AJUSTES, ...nuevos }),
    );
    return nuevos;
  },

  async marcarOnboardingVisto(): Promise<void> {
    await ajustesRepo.guardar({ onboardingVisto: true });
  },
};
